export default "__VITE_PUBLIC_ASSET__2006fb78__"